export default {
  // ADD ARI
  "add-ari_page-title": "Add an Individual for Authorization",
  "add-ari_page-description": "Note: This authorization will remain in effect until the expiration date.",
  "add-ari_text_loading-message": "Saving ARI Designee…",
  "add-ari_text_success-message": "Add ARI Success",
  "add-ari_text_error-message": "Add ARI Error",
  "add-ari_text_refresh-data-error-message": "Your ARI has been added but we were unable to refresh the data on the screen. Please refresh the page.",
  "___add-ari_action_done": "",
  "add-ari_action_submit": "Submit",
  "___add-ari_title_confirm-close": "",
  "___add-ari_text_confirm-close": "",
  "___add-ari_action_confirm-close_cancel": "",
  "___add-ari_action_confirm-close_confirm": "",
  "___add-ari_form-label_first-name": "",
  "___add-ari_form-label_last-name": "",
  "add-ari_form-label_expiration-date": "Expiration Date",
  "add-ari_form-hint_expiration-date": "MM/DD/YYYY",
  "add-ari_text_expiration-date-notice": "Note: This authorization will remain in effect until the expiration date.",
  "add-ari_form-error_first-name_required": "First Name is required",
  "add-ari_form-error_first-name_max-length": "First Name cannot be more than %maxLength% characters",
  "add-ari_form-error_last-name_required": "Last Name is rquired",
  "add-ari_form-error_last-name_max-length": "Last Name cannot be more than %maxLength% characters",
  "add-ari_form-error_expiration-date_invalid-format": "Invalid Expiration Date",
  "add-ari_form-error_expiration-date_min-date": "Expiration Date cannot be prior to the current date.",
  "add-ari_form-error_expiration-date_max-date": "Expiration Date must be prior to %compareDate%",
  "add-ari_form-error_expiration-date_required": "Expiration date is required",

  // UPDATE ARI
  "update-ari_page-title": "Edit ARI Designee",
  "update-ari_page-description": "Authorize the person below to receive information on your account when they call Customer Service.",
  "update-ari_text_loading-message": "Saving ARI Designee…",
  "update-ari_text_success-message": "Update ARI Success",
  "update-ari_text_error-message": "Update ARI Error",
  "update-ari_text_refresh-data-error-message": "Your ARI has been updated but we were unable to refresh the data on the screen. Please refresh the page.",
  "___update-ari_action_done": "",
  "update-ari_action_submit": "Next",
  "___update-ari_title_confirm-close": "",
  "___update-ari_text_confirm-close": "",
  "___update-ari_action_confirm-close_cancel": "",
  "___update-ari_action_confirm-close_confirm": "",
  "___update-ari_form-label_first-name": "",
  "___update-ari_form-label_last-name": "",
  "update-ari_form-label_expiration-date": "Expiration Date",
  "update-ari_form-hint_expiration-date": "MM/DD/YYYY",
  "update-ari_text_expiration-date-notice": "Note: This authorization will remain in effect until the expiration date.",
  "update-ari_form-error_first-name_required": "First Name is required",
  "update-ari_form-error_first-name_max-length": "First Name cannot be more than %maxLength% characters",
  "update-ari_form-error_last-name_required": "Last Name is rquired",
  "update-ari_form-error_last-name_max-length": "Last Name cannot be more than %maxLength% characters",
  "update-ari_form-error_expiration-date_invalid-format": "Invalid Expiration Date",
  "update-ari_form-error_expiration-date_min-date": "Expiration Date cannot be prior to the current date.",
  "update-ari_form-error_expiration-date_max-date": "Expiration Date must be prior to %compareDate%",
  "update-ari_form-error_expiration-date_required": "Expiration date is required",

  // REMOVE PROVIDER
  "remove-ari_page-title": "Please confirm you would like to delete this ARI Designee",
  "remove-ari_page-description": "By deleting this authorization, the person you've chosen won't be able to contact us on your behalf.",
  "___remove-ari_action_done": "",
  "___remove-ari_action_cancel": "",
  "___remove-ari_action_confirm": "",
  "___remove-ari_title_confirm-close": "",
  "___remove-ari_text_confirm-close": "",
  "___remove-ari_action_confirm-close_cancel": "",
  "___remove-ari_action_confirm-close_confirm": "",
  "remove-ari_text_loading-message": "Removing ARI Designee…",
  "remove-ari_text_success-message": "The authorization has been removed.",
  "___remove-ari_text_error-message_default": "",
  "remove-ari_text_refresh-data-error-message": "Your ARI has been deleted but we were unable to refresh the data on the screen. Please refresh the page.",
};